import { getRotateShiftSubOperations } from './rotate-shift-operations.js';
import { getBitSubOperations } from './bit-operations.js';
import { getSetSubOperations } from './set-operations.js';
import { getResSubOperations } from './res-operations.js';
export function createCbSubOperations() {
    const cpu = this;
    this.addOperation({
        instruction: '',
        byteDefinition: 0xcb,
        cycleTime: 0,
        byteLength: 0,
        execute() {
            const cbOperationIndex = cpu.memory.readByte(cpu.registers.programCounter.value);
            cpu.registers.programCounter.value++;
            const subOperation = cpu.cbSubOperationMap[cbOperationIndex];
            subOperation.execute();
        }
    });
    getRotateShiftSubOperations(cpu);
    getBitSubOperations(cpu);
    getSetSubOperations(cpu);
    getResSubOperations(cpu);
}
//# sourceMappingURL=cb-operation.js.map